import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useAreBranchesLoadedFromServerSelector = () => {
  const state = useGetEditOrActual();

  return useMemo(() => state.areBranchesLoadedFromServer, [state.areBranchesLoadedFromServer]);
};
